import { createContext, useContextSelector } from '@fluentui/react-context-selector';

export const CustomListDropdownMenuSelectionContext = createContext<number | undefined>(undefined);

export const useIsSelected = (index: number) =>
    useContextSelector(CustomListDropdownMenuSelectionContext, (value) => value === index);
